///*eslint-disable jsx-a11y/aria-role */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Row,
  Container,
  Navbar,
  Nav,
  NavDropdown,
  OverlayTrigger,
  Popover,
  Col,
  Accordion,
  Card,
} from 'react-bootstrap';
//import './header.scss';
import { useSelector, useDispatch } from 'react-redux';
import MasterPermissions from '../../api/MasterPermissions';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { logout } from '../../../redux/app/userSlice';
import { useTranslation } from 'react-i18next';
import { AccordionDownArrow } from 'src/Member/img/findcare/FindCareSVG';
import {
  ToolTipNotificationBellSVG,
  NotificationBellSVG,
  NotificationBellSVGWithBadge,
} from 'src/Member/img/NotificationSVG';
//import HelpCenterImage from '../../img/Help-Center.svg';
//import NotificationPopup from '../Message&Documents/NotificationPopup';
import Avatar from 'src/Member/components/common/avatar-with-initials';
import { HelpCenterNew as HelpIcon } from 'src/Admin/img/HelpCenterNew';
import APIEndpoints from '../../../Admin/api/APIEndpoints'; //getNotificationcountapi
import { axiosInstance } from '../../../../src/api/axios';
import './portalName.scss';
import { getPortalName } from 'src/utils';
import NotificationPopup from '../Documents/NotificationPopup';
import OutsideClickHandler from 'react-outside-click-handler';
import {
  setIsDataFeching,
  setNotificationResp,
} from 'src/redux/app/messageAndNotificationSlice';
import NotificationPopupSkeleton from 'src/Components/skeletons/NotificationPopupSkeleton';

const PortalName = ({ isPublic, isSecure }) => {
  const { t } = useTranslation();
  const { isLogoLoaded, logoImage, logoType } = useSelector(
    (state) => state.theme,
  );
  const { isLoggedIn, userData } = useSelector((state) => state.user);
  const { NotificationResp, isDataFeching } = useSelector(
    (state) => state?.messageAndNotification,
  );
  const [isMenuDisabled, setMenuDisabled] = useState(false);
  //const [notificationCount, setNotificationCount] = useState('9');
  const [activeId, setActiveId] = useState(0);
  const [showNotificationBody, setShowNotificationBody] = useState('0');
  const [showNotification, setShowNotification] = useState(true);
  const [getNotificationCount, setGetNotificationCount] = useState([]);
  const [messageDetails, setMessageDetails] = useState([]);
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const FEATURES = Features_Setting;
  const [viewDocuments, setViewDocuments] = useState(false);
  const notificationCount = '9';
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logoutAction = () => {
    dispatch(logout({ preserveBearerToken: true }));
    //dispatch(resetRecentSearchList());
    navigate('/admin/logout');
    console.log('A Portal Logout -> isAuthenticated: ');
  };

  const mainHeading = getPortalName().mainHeadeing;
  const subHeading = isLoggedIn
    ? getPortalName(userData.UserType).subHeading || 'Admin Center'
    : 'Admin Center';

  useEffect(() => {
    if (
      location.pathname.includes('/member/page/') &&
      location.search.includes('&newTab')
    ) {
      setMenuDisabled(true);
    } else {
      setMenuDisabled(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    //Check Send Document
    const sendDocumentFlag =
      FEATURES && FEATURES?.find((feature) => feature.Name === 'SendDocument');
    sendDocumentFlag && sendDocumentFlag.Status === true
      ? setViewDocuments(true)
      : setViewDocuments(false);
  }, [FEATURES]);

  useEffect(() => {
    setShowNotificationBody('0');
    if (location.pathname.includes('admin/admin-dashboard')) {
      setShowNotification(false);
    } else {
      setShowNotification(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isSecure === true) {
      notificationCountList();
    }
  }, [isSecure]);

  //getNotificationcountapi
  const notificationCountList = async () => {
    dispatch(setIsDataFeching(true));
    try {
      const responseNotification = await axiosInstance.get(
        APIEndpoints.getNotificationcountapi(),
      );
      const MessageCounts =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageCount;
      const MessageDetails =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageDetail;
      dispatch(
        setNotificationResp(
          responseNotification?.data?.Response?.ResponseObectForNotification,
        ),
      );
      setGetNotificationCount(MessageCounts);
      setMessageDetails(MessageDetails);
      return 'success';
    } catch (error) {
      return 0;
    } finally {
      dispatch(setIsDataFeching(false));
    }
  };

  const TotalMessageAndNotificationCount =
    Number(NotificationResp?.MessageCount?.Message) +
    Number(NotificationResp?.MessageCount?.Notification);

  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  const notificationShowHideHandler = async () => {
    if (showNotification == false) {
      const resp = await notificationCountList();
      if (resp) {
        setShowNotification(true);
        setShowNotificationBody(null);
      }
    } else {
      setShowNotification(!showNotification);
      setShowNotificationBody('0');
    }
  };

  const closeNotificationHandler = () => {
    setShowNotification(false);
  };

  return (
    <div>
      <OutsideClickHandler
        onOutsideClick={(e) => {
          if (showNotification == true) {
            setShowNotification(false);
          }
        }}
      >
        <div className="portal-name-container d-flex justify-content-md-end">
          <Helmet>
            <meta charSet="utf-8" />
            <title>{`${mainHeading} - ${subHeading}`}</title>
          </Helmet>
          <div
            className={`d-flex flex-column header-sub-section portal-name-subsection ${
              isSecure ? 'border-right' : ''
            }`}
          >
            {/*#TODO: make dynamic */}
            <p className="m-0 p-0 text-right main-heading">
              {/*{getPortalName().mainHeadeing}*/}
              {mainHeading}
            </p>
            {/*#TODO: make dynamic */}
            <p className="m-0 p-0 text-right sub-heading">
              {/*{isLoggedIn
            ? getPortalName(userData.UserType).subHeading || 'Admin Center'
            : 'Admin Center'}*/}
              {subHeading}
            </p>
          </div>
          {isSecure && (
            <>
              <div className="header-sub-section d-flex align-items-center">
                <Link to="/admin/help-center" className="help-icon-main">
                  {/*<img src={HelpCenterImage} alt="logo" />*/}
                  <div className="help-icon-container">
                    <HelpIcon className={'help-icon'} />
                  </div>
                </Link>
              </div>
              {viewDocuments && (
                <div className="header-sub-section d-flex align-items-center">
                  <div className="notification">
                    <OverlayTrigger
                      show={showNotification || isDataFeching}
                      placement="bottom-end"
                      delay={{ show: 200, hide: 450 }}
                      overlay={
                        <Popover className="popover_notification">
                          <Popover.Content>
                            <Accordion eventKey="0">
                              {isDataFeching ? (
                                <Card>
                                  <NotificationPopupSkeleton />
                                </Card>
                              ) : (
                                <Card>
                                  <Accordion.Toggle
                                    as={Card.Header}
                                    onClick={() => {
                                      setShowNotification(true),
                                        toggleActive(0);
                                    }}
                                    className="panel-toggle text-left w-100"
                                    eventKey="0"
                                  >
                                    <div className="d-flex panel-card-header">
                                      <div className="accordian-notification">
                                        <Row className="notification-tooltip justify-content-between align-items-center">
                                          <Col className="notification-icon">
                                            {/*<img className="header-notification-icon" src={TooltipNotificationIcon} alt="logo"/> */}
                                            <ToolTipNotificationBellSVG />
                                          </Col>
                                          <Col
                                            className={`${
                                              TotalMessageAndNotificationCount >
                                              0
                                                ? 'pl-3'
                                                : ''
                                            } notification-content " `}
                                          >
                                            {TotalMessageAndNotificationCount >
                                            0 ? (
                                              <>
                                                <span className="tooltip-header">
                                                  You have{' '}
                                                  {
                                                    TotalMessageAndNotificationCount
                                                  }{' '}
                                                  Notifications
                                                </span>
                                                <br />
                                                <div className="tooltip-content-text">
                                                  {
                                                    NotificationResp
                                                      ?.MessageCount?.Message
                                                  }{' '}
                                                  Messages and{' '}
                                                  {
                                                    NotificationResp
                                                      ?.MessageCount
                                                      ?.Notification
                                                  }{' '}
                                                  Updates / Reminders
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                <div className="No-notifications-found">
                                                  You don’t have any
                                                  notification right now.
                                                </div>
                                              </>
                                            )}
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                  </Accordion.Toggle>

                                  <Accordion.Collapse
                                    eventKey={showNotificationBody}
                                  >
                                    <Card.Body>
                                      <NotificationPopup
                                        getNotificationCount={
                                          NotificationResp?.MessageCount
                                        }
                                        messageDetails={messageDetails}
                                        setShowNotification={
                                          setShowNotification
                                        }
                                      />
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              )}
                            </Accordion>
                          </Popover.Content>
                        </Popover>
                      }
                    >
                      <div
                        className="header-notification-div"
                        onClick={() => notificationShowHideHandler()}
                      >
                        {TotalMessageAndNotificationCount > 0 ? (
                          <NotificationBellSVGWithBadge
                            className="header-notification-svg"
                            parentClassName="background-notification-svg"
                            badgeClassName="header-notification-badge-svg"
                          />
                        ) : (
                          <NotificationBellSVG
                            className="header-notification-svg"
                            parentClassName="background-notification-svg"
                          />
                        )}
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              )}

              <div className="header-sub-section d-flex align-items-center">
                <Navbar collapseOnSelect expand="lg" className="header-navbar">
                  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                  <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto"></Nav>
                    {isLoggedIn && (
                      <Nav className="user-navbar">
                        <NavDropdown
                          onClick={() => closeNotificationHandler()}
                          title={
                            <div className="d-flex user-avatar-container">
                              <Avatar
                                fname={userData?.FirstName}
                                lname={userData?.LastName}
                                className={'size-32'}
                              />
                              <AccordionDownArrow className="acc-arrow" />
                            </div>
                          }
                          id={'collasible-nav-dropdown-header'}
                        >
                          <NavDropdown.Item href="#" className="active">
                            <div className="d-flex user-name-profile-container">
                              <Avatar
                                fname={userData?.FirstName}
                                lname={userData?.LastName}
                              />
                              <div className="user-info">
                                <p className="user-name m-0">{`${userData?.FirstName} ${userData?.LastName}`}</p>
                                <p className="user-role m-0">
                                  {/*{userData.SuperUser
                                ? 'Super Admin'
                                : userData.UserType}*/}
                                  {userData.UserType}
                                </p>
                              </div>
                            </div>
                          </NavDropdown.Item>

                          <NavDropdown.Item as={Link} to="/admin/my-profile">
                            My Profile
                          </NavDropdown.Item>
                          <NavDropdown.Item href="#" onClick={logoutAction}>
                            Logout
                          </NavDropdown.Item>
                          <NavDropdown.Divider />
                        </NavDropdown>
                      </Nav>
                    )}
                  </Navbar.Collapse>
                </Navbar>
              </div>
            </>
          )}
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default PortalName;
